import { createApiClientWithAuth } from '@/libs/api/base/api-client.ts'
import type {
  ApiClientOptions,
  ApiClientWithAuth,
  AuthRequest,
  ResponseWrapper
} from '@/libs/api/base/api.types.ts'
import type {
  ConnectPartnerConfigResponse,
  ConnectPartnerTrackingRequestBody,
  ConnectTrackingResponse
} from '@/libs/api/connect/connect.types.ts'

export type ShopConnectApiClient = {
  getPartnerConfig: () => Promise<ConnectPartnerConfigResponse>
  partnerTracking: (body: ConnectPartnerTrackingRequestBody) => Promise<ConnectTrackingResponse>
} & ApiClientWithAuth

export const useConnectApiClient = (
  auth: Omit<AuthRequest, 'grant_type'>,
  options?: Partial<ApiClientOptions>
): ShopConnectApiClient => {
  const defaultOptions = {
    key: 'shopconnect',
    prefixUrl: import.meta.env.VITE_CONNECT_BASE_URL,
    auth
  }

  const client = createApiClientWithAuth({
    ...defaultOptions,
    ...options
  })

  return {
    ...client,

    async getPartnerConfig(): Promise<ConnectPartnerConfigResponse> {
      return (
        await client.get<ResponseWrapper<ConnectPartnerConfigResponse>>('api/v1/partner/config')
      ).data as ConnectPartnerConfigResponse
    },

    async partnerTracking(
      body: ConnectPartnerTrackingRequestBody
    ): Promise<ConnectTrackingResponse> {
      return (await client.post<ConnectPartnerTrackingRequestBody, ConnectTrackingResponse>(
        'api/v1/partner/tracking',
        body
      )) as ConnectTrackingResponse
    }
  }
}
